import gql from 'graphql-tag';

const SUBSCRIPTION_PLANS_QUERY = gql`
  query getSubscriptionPlans {
    getSubscriptionPlans {
      id,
      name,
      totalToken,
      duration,
      tickets
    }
  }
`

export default SUBSCRIPTION_PLANS_QUERY;